// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_readLibraryDoc = (path: TSpecPathReadLibraryDoc) => {
  let res = "/library/docs/:libraryDocId/read";
  Object.entries(path).map(([key, value]) => {
    res = res.replace(':' + key, value);
  });
  return res;
};

export type TSpecHandler_readLibraryDoc = RequestHandler<TSpecPathReadLibraryDoc, any, TSpecBodyReadLibraryDoc, TSpecQueryReadLibraryDoc, {}>;

export interface TSpecPathReadLibraryDoc { libraryDocId: string; }

export interface TSpecBodyReadLibraryDoc {}

export interface TSpecQueryReadLibraryDoc {
  AppVersion?: string;
  AppUser?: string;
}
